import { ExpandMoreRounded } from '@mui/icons-material';
import { getName } from '@/reports/index';
import { serializedTypes } from '@/reports/types';
import { Select } from '@/theme/index';
import { nameize } from '@/utils/index';

export const PotentialOwnersDropdown = ({
  potentialOwners,
  potentialOwnerIndex,
  setPotentialOwnerIndex,
}: {
  potentialOwners: serializedTypes.SerializedPerson[];
  potentialOwnerIndex: number;
  setPotentialOwnerIndex: (index: number) => void;
}) => {
  const options = potentialOwners.map((owner, index: number) => ({
    value: `${index}`,
    display: nameize(getName(owner)),
  }));
  return (
    <Select
      sx={{ fontSize: '1.25rem' }}
      IconComponent={ExpandMoreRounded}
      options={options}
      onOptionSelect={(value) => {
        setPotentialOwnerIndex(+value);
      }}
      id="potential-owners-dropdown"
      value={`${potentialOwnerIndex}`}
    />
  );
};
